import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { AuthorizedUser, UPUtilityService, ltiParams } from 'up';
import { environment } from '../environments/environment';
import { getLtiParams } from './shared/store/selectors/ltiparams.selector';
import { LtiParamsState } from './shared/store/state/ltiparams.state';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements OnDestroy {
  private destroy$ = new Subject<boolean>();
  ltiParams$: Observable<ltiParams> = this.store.select(getLtiParams);
  constructor(
    private router: Router,
    private store: Store<LtiParamsState>,
    private upUtilityService: UPUtilityService,
    private translate: TranslateService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    let role!: string,
      ltiaAction!: string,
      isAuthorized: boolean = false;
    const userAuthorizedData: AuthorizedUser = route?.data;
    this.ltiParams$
      .pipe(takeUntil(this.destroy$), take(1))
      .subscribe((ltiParams: ltiParams) => {
        role = ltiParams.role.toLowerCase();
        ltiaAction = ltiParams.ltiaAction.toLowerCase();
        isAuthorized = this.upUtilityService.hasAuthorizedAccess(
          userAuthorizedData,
          role,
          ltiaAction,
        );
        if (!isAuthorized) {
          this.translate
            .get(['GENERIC.UNAUTHORIZED.PAGE_TITLE', 'GENERIC.PAGE_TITLE'])
            .subscribe({
              next: (translatedText) => {
                const unAuthorizedpageTitle =
                  translatedText['GENERIC.UNAUTHORIZED.PAGE_TITLE'];
                const pageTitle = translatedText['GENERIC.PAGE_TITLE'];
                this.router.navigate(['/unauthorized'], {
                  state: {
                    deleteUrl: `${environment.apiUrl}/vl`,
                    pageTitle: pageTitle + unAuthorizedpageTitle,
                  },
                });
              },
            });
        }
      });
    return isAuthorized;
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
